import React, { useCallback, useContext, useEffect, useState } from 'react';
import { GetDocumentByInfoExtras } from '../../api/Clients/getClientDocumentForm.api';
import * as ORIGINAL_HREF from '../../constants/originalHref';
import * as ALL_DOCUMENTS from '../../constants/helloSignDocumentInfo';
import { TextareaAutosize } from '@material-ui/core';
import LotModel from './lotModel/LotModel';
import dayjs from 'dayjs';

export function CreateDocumentForm(
	client,
	extraDoc,
	expandedClient,
	firebase,
	setShowExtraDoc,
	customFields,
	setCustomFields,
	select,
	setSelect,
	otherCustomFields,
	setOtherCustomFields,
	customSignersFromClient,
	setCustomSigners
) {
	var myCustomSigners = customSignersFromClient;
	console.log('Start extraDoc.overideRoles ', extraDoc.overideRoles);
	console.log('My custom signers ', myCustomSigners);

	const textAreaRow = {
		formhalf: 2,
		formfull: 2,
		formfullLarge: 5,
	};

	var currentUserEmail = firebase.auth().currentUser.email;

	const range = (entered, start, end) => {
		/* generate a range : [start, start+1, ..., end-1, end] */
		var len = end - start + 1;
		var a = new Array(len);
		for (let i = 0; i < len; i++) a[i] = entered[start + i];
		return a;
	};

	const getInfoRecursively = (currentJson, restOfList) => {
		console.log('Looking for ' + restOfList[0]);

		if (restOfList.length > 1) {
			console.log('restOfList' + restOfList);

			var newList = range(restOfList, 1, restOfList.length - 1);

			return getInfoRecursively(currentJson[restOfList[0]], newList);
		} else {
			console.log(' Returning ' + currentJson[restOfList[0]]);
			if (currentJson[restOfList[0]]) {
				return currentJson[restOfList[0]];
			} else {
				return '';
			}
		}
	};

	const valueUpdateCustomFields = (e) => {
		// customFields[e.target.name] = e.target.value;
		// console.log(
		// 	'custom fields valueUpdateCustomFields' + JSON.stringify(customFields)
		// );

		const values = {
			...customFields,
			// , otherCustomFields
		};

		values[e.target.name] = e.target.value;
		setCustomFields(values);
	};

	const updateCustomFields = (name, value) => {
		customFields[name] = value;
		console.log(
			'custom fields valueUpdateCustomFields' +
				JSON.stringify(customFields)
		);
	};

	const updateCustomSigners = (role, value) => {
		myCustomSigners[role] = value;
		console.log('customSigners ' + JSON.stringify(customSignersFromClient));
	};

	const turnCustomFieldToHelloSign = (customFields) => {
		var finalCustom = [];

		var allKeys = Object.keys(customFields);

		console.log('turnCustomFieldToHelloSign allKeys: ', allKeys);

		allKeys.forEach((key) => {
			var newJson = {
				name: key,
				value: customFields[key],
			};

			finalCustom.push(newJson);
		});

		console.log('turnCustomFieldToHelloSign finalCustom: ', finalCustom);

		return finalCustom;
	};

	const turnSignerFieldToHelloSign = (
		extraDoc,
		_customSigners,
		customFields,
		_newCustomFields
	) => {
		// console.log(' extraDoc.overideRoles start', extraDoc.overideRoles);
		// console.log(
		// 	'extraDoc.overideRoles.length ',
		// 	extraDoc.overideRoles.length
		// );
		// console.log('_customSigners', _customSigners);
		if (extraDoc.overideRoles != undefined) {
			var signerJson = [];

			var i = 0;
			for (i = 0; i <= extraDoc.overideRoles.length - 1; i++) {
				console.log('INSIDE');
				var test1 = {
					email_address: ' ',
					role: extraDoc.overideRoles[i].role,
					name: ' ',
				};
				signerJson.push(test1);

				if (
					extraDoc.overideRoles[i.toString()].email_address === 'fill'
				) {
					signerJson[i].email_address =
						_customSigners[extraDoc.overideRoles[i].role];
				} else {
					signerJson[i].email_address =
						extraDoc.overideRoles[i.toString()].email_address;
				}

				console.log(
					' signerJson[i].email_address ',
					signerJson[i].email_address
				);
				console.log(
					' extraDoc.overideRoles[i].email_field ',
					extraDoc.overideRoles[i].email_field
				);
				var blank = {};
				if (
					signerJson[i].email_address === undefined &&
					extraDoc.overideRoles[i].email_field !== null
				) {
					console.log('I SHOULD BE IN HERE ');
					signerJson[i].email_address =
						_newCustomFields[extraDoc.overideRoles[i].email_field]; //loop through this?
					console.log(
						'extraDoc.overideRoles[i].name',
						extraDoc.overideRoles[i].name
					);
					signerJson[i].email_address =
						customFields[extraDoc.overideRoles[i].email_field];

					console.log(
						'_newCustomFields_newCustomFields',
						_newCustomFields
					);

					for (
						let index = 0;
						index < _newCustomFields.length;
						index++
					) {
						if (
							_newCustomFields[index].name ===
							extraDoc.overideRoles[i].email_field
						) {
							signerJson[i].email_address =
								_newCustomFields[index].value;
						}
					}
				}

				if (
					extraDoc.overideRoles[i.toString()].findName !==
						undefined &&
					extraDoc.overideRoles[i.toString()].findName === true
				) {
					console.log(
						'FIND USER NAME ' + extraDoc.overideRoles[i].name
					);
					signerJson[i].name =
						customFields[extraDoc.overideRoles[i].name];
				} else {
					signerJson[i].name = extraDoc.overideRoles[i].name;
				}

				if (
					signerJson[i].name === undefined &&
					extraDoc.overideRoles[i].name !== null
				) {
					for (
						let index = 0;
						index < _newCustomFields.length;
						index++
					) {
						console.log(
							'am i in the ifffff',
							_newCustomFields[index].name,
							extraDoc.overideRoles[i].name
						);
						if (
							_newCustomFields[index].name ===
							extraDoc.overideRoles[i].name
						) {
							signerJson[i].name = _newCustomFields[index].value;
						}
					}
				}
			}
			console.log(
				' extraDoc.overideRoles finished',
				extraDoc.overideRoles
			);
			console.log('turnSignerFieldToHelloSign finalSigner: ', signerJson);
			return signerJson;
		} else {
			return undefined;
		}
	};

	const handleSubmitDoc = (e) => {
		e.preventDefault();
		console.log('handleSubmitDoc', JSON.stringify(customFields));
		var shouldWeUseSecondPurchaser = false;

		if (
			client.documentInformation.document.individualSecondPurchaserDetails
				?.email !== undefined &&
			client.documentInformation.document.individualSecondPurchaserDetails
				?.email !== ''
		) {
			shouldWeUseSecondPurchaser = true;
		}

		console.log('HANDLE SUBMIT cus', myCustomSigners);

		var newCustomFields = turnCustomFieldToHelloSign(customFields);

		var turnInto = turnSignerFieldToHelloSign(
			extraDoc,
			myCustomSigners,
			customFields,
			newCustomFields
		);

		console.log('Var returned info turnInto  ', turnInto);

		GetDocumentByInfoExtras(
			expandedClient,
			client,
			extraDoc,
			ORIGINAL_HREF.originalHREF['access_token'],
			currentUserEmail,
			newCustomFields,
			turnInto,
			shouldWeUseSecondPurchaser
		);
		setShowExtraDoc(false);
		setCustomSigners = {};
		myCustomSigners = {};
	};

	const handleSelect = (e, info) => {
		console.log(e.currentTarget.dataset.id);
		var names = e.currentTarget.dataset.name;
		setSelect(e.currentTarget.dataset.id);
		var modelSelected = info;
		setOtherCustomFields({ [names]: modelSelected });
	};

	const determineFormField = (formItem, totalAutoFillInfo) => {
		const { constComponent } = formItem;
		switch (constComponent) {
			case 'lot_model':
				return (
					<LotModel
						formItem={formItem}
						documentPath={client.documentInformation.document}
						totalAutoFillInfo={totalAutoFillInfo}
						select={select}
						setSelect={setSelect}
						handleSelect={handleSelect}
					/>
				);
			default:
				break;
		}
	};

	var shouldWeSendAlert;
	var alertMessage;
	customSignersFromClient = {};
	return (
		<div className='extra_form_wrapper'>
			<form>
				{extraDoc.formItems?.map((formItem) => {
					console.log('formItems', formItem);

					if (formItem.tryAutoFill === true) {
						//here we will get the info from client
						var totalAutoFillInfo = '';
						var totalAutoFillFloat = 0;

						formItem.autoFillInfo.forEach((partOfFormInfo) => {
							var allItemForInfo = partOfFormInfo.split('/');

							if (allItemForInfo.length > 1) {
								totalAutoFillInfo =
									totalAutoFillInfo +
									'' +
									getInfoRecursively(
										client.documentInformation.document,
										allItemForInfo
									) +
									'';
							} else {
								if (
									formItem.convertToPrice !== undefined &&
									formItem.convertToPrice === true
								) {
									totalAutoFillFloat =
										totalAutoFillFloat +
										parseFloat(
											client.documentInformation.document[
												allItemForInfo[0]
											]
										);
									totalAutoFillInfo = new Intl.NumberFormat(
										'en-US',
										{
											style: 'currency',
											currency: 'USD',
										}
									).format(totalAutoFillFloat);
								} else {
									totalAutoFillInfo =
										totalAutoFillInfo +
										'' +
										client.documentInformation.document[
											allItemForInfo[0]
										] +
										'';
								}
							}

							if (formItem.autoFillInfo.length > 1) {
								totalAutoFillInfo = totalAutoFillInfo + ' ';
							}
						});
						totalAutoFillInfo = totalAutoFillInfo.trim();

						//make this a signer instead of a custom_field
						if (
							formItem.changeToSigner !== undefined &&
							formItem.changeToSigner
						) {
							updateCustomSigners(
								formItem.role,
								totalAutoFillInfo
							);
						} else {
							updateCustomFields(
								formItem.customField,
								totalAutoFillInfo
							);
						}
						// we can autofill this item now

						return (
							<div className='label_wrapper_extra'>
								<label htmlFor=''>{formItem.title}</label>
								<input
									className={'form' + formItem.fieldSize}
									type='text'
									name={formItem.customField}
									value={totalAutoFillInfo}
									disabled='disabled'
								/>
							</div>
						);
					} else if (
						formItem.getApsSignedDate !== undefined &&
						formItem.getApsSignedDate === true
					) {
						//dayjs(realFirstDate).unix() * 1000 +  (86400000 * 45)
						//= dayjs(dayjs(realFirstDate).unix() * 1000 +  (86400000 * 365)).format('DD MMM YYYY');
						if (
							formItem.addToDate !== undefined &&
							formItem.addToDate === true
						) {
							var apsInfo = FindApsFirstSignatureDate(client);

							if (apsInfo.apsIsReady === true) {
								var apsFirstDate = apsInfo.lastSigDate;
								var addExtraDays = formItem.value;

								var dateSet = dayjs(
									dayjs(apsFirstDate * 1000).unix() * 1000 +
										86400000 * addExtraDays
								).format('DD MMM YYYY');

								updateCustomFields(
									formItem.customField,
									dateSet
								);
								return (
									<div className='label_wrapper_extra'>
										<label htmlFor=''>
											{formItem.title}
										</label>

										<TextareaAutosize
											className={
												'form' + formItem.fieldSize
											}
											type='text'
											rows={
												textAreaRow[
													'form' + formItem.fieldSize
												]
											}
											maxLength='500'
											name={formItem.customField}
											value={dateSet}
											onChange={(e) =>
												valueUpdateCustomFields(e)
											}
										/>
									</div>
								);
							}
						}
					} else if (
						formItem.setField !== undefined &&
						formItem.setField === true
					) {
						updateCustomFields(
							formItem.customField,
							formItem.value
						);
						return (
							<div className='label_wrapper_extra'>
								<label htmlFor=''>{formItem.title}</label>

								<TextareaAutosize
									className={'form' + formItem.fieldSize}
									type='text'
									rows={
										textAreaRow['form' + formItem.fieldSize]
									}
									maxLength='500'
									name={formItem.customField}
									value={formItem.value}
									onChange={(e) => valueUpdateCustomFields(e)}
								/>
							</div>
						);
					} else {
						console.log(
							'I am in the else ',
							JSON.stringify(formItem)
						);

						var totalAutoFillInfo = '';

						formItem?.autoFillInfo?.forEach((partOfFormInfo) => {
							var allItemForInfo = partOfFormInfo.split('/');

							console.log('allItemForInfo: ', allItemForInfo);

							if (allItemForInfo.length > 1) {
								totalAutoFillInfo =
									totalAutoFillInfo +
									' ' +
									getInfoRecursively(
										client.documentInformation.document,
										allItemForInfo
									);
							} else {
								totalAutoFillInfo =
									client.documentInformation.document[
										allItemForInfo
									];
							}
						});
						console.log(
							'This is the totalatofill other: ' +
								JSON.stringify(totalAutoFillInfo)
						);

						return (
							<div className='label_wrapper_extra'>
								<label htmlFor=''>{formItem.title}</label>

								<TextareaAutosize
									className={'form' + formItem.fieldSize}
									type='text'
									rows={
										textAreaRow['form' + formItem.fieldSize]
									}
									maxLength='500'
									name={formItem.customField}
									value={
										customFields[formItem.customField]
											? customFields[formItem.customField]
											: ''
									}
									onChange={(e) => valueUpdateCustomFields(e)}
								/>

								{determineFormField(
									formItem,
									totalAutoFillInfo
								)}
							</div>
						);
					}
				})}
				<button
					className='btn btn-primary'
					onClick={(e) => {
						console.log(
							'Before submit extraDoc.overideRoles finished',
							extraDoc.overideRoles
						);
						handleSubmitDoc(e);
					}}
				>
					Create Document
				</button>
			</form>
		</div>
	);
}

function FindApsFirstSignatureDate(client) {
	var documentSignaturesRequest =
		client.documentInformation.signatureRequests;

	//Object.keys(objBuilder);
	var documentSignaturesRequestKeys = Object.keys(documentSignaturesRequest);

	var i;
	var apsIsReady = false;
	var apsLastWitnessSignatureTime;
	for (i = documentSignaturesRequestKeys.length - 1; i >= 0; i--) {
		if (
			documentSignaturesRequest[documentSignaturesRequestKeys[i]]
				.subject ===
			ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo.subjectName
		) {
			var correctSigUpdates =
				documentSignaturesRequest[documentSignaturesRequestKeys[i]]
					.signatureUpdates;

			var sigUpdateKeys = Object.keys(correctSigUpdates);

			var q;

			for (q = 0; q < sigUpdateKeys.length; q++) {
				var thisSigUp = correctSigUpdates[sigUpdateKeys[q]];
				if (thisSigUp.signature_request != undefined) {
					var allSigs = thisSigUp.signature_request.signatures;
					var lastWitnessSignature = allSigs[allSigs.length - 3]; //last possible witness
					if (lastWitnessSignature.status_code === 'signed') {
						apsLastWitnessSignatureTime =
							thisSigUp.event.event_time;
						apsIsReady = true;
					}
				}
			}

			i = 0;
		}
	}

	if (apsIsReady === true) {
		console.log('Eft sig update time ' + apsLastWitnessSignatureTime);
		return { apsIsReady: true, lastSigDate: apsLastWitnessSignatureTime };
	} else {
		return {
			apsIsReady: false,
			message: 'APS is not signed by all witness no dates will ',
		};
	}
}
